import PopUp from '@/common/components/PopUp';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { BottomText, ButtonWrapper, Title, Wrapper } from './BackPopUp.styles';
import GradientButton from '@/common/components/custom/buttons/GradientButton';

type Props = { onContinue: () => void; onBack: () => void };

function BackPopUp({ onContinue, onBack }: Props) {
	const langData = useLanguageData('features.sceneV3');

	return (
		<PopUp setClose={onContinue}>
			<Wrapper>
				<Title>{langData.areYouSureYouWantToLeave}</Title>
				<ButtonWrapper>
					<GradientButton
						title={langData.continue}
						style={buttonStyles}
						onClick={onContinue}
					/>
					<GradientButton
						inverted
						title={langData.leave}
						style={buttonStyles}
						onClick={onBack}
					/>
					<BottomText>({langData.youWillLoseProgress})</BottomText>
				</ButtonWrapper>
			</Wrapper>
		</PopUp>
	);
}

export default BackPopUp;

const buttonStyles = {
	width: 200,
	height: 35,
	fontSize: 14,
	justifySelf: 'center',
};
